'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBoxStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALIGN_MAP = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};

var align = function align(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var alignSelf = theme.reactackle.components.breadcrumbs.item.icon.alignSelf;


  return 'align-self: ' + ALIGN_MAP[alignSelf] + ';';
};

var size = function size(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.breadcrumbs.item.icon,
      height = _theme$reactackle$com.height,
      width = _theme$reactackle$com.width,
      imgHeight = _theme$reactackle$com.imgHeight,
      imgWidth = _theme$reactackle$com.imgWidth,
      marginLeft = _theme$reactackle$com.marginLeft,
      marginY = _theme$reactackle$com.marginY;


  return (0, _styledComponents.css)(['margin:', ' 0;margin-left:', ';', ''], (0, _reactackleCore.getValueString)(marginY), (0, _reactackleCore.getValueString)(marginLeft), (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
};

var colorScheme = function colorScheme(_ref3) {
  var colorScheme = _ref3.colorScheme,
      themeFromProvider = _ref3.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.breadcrumbs.item.icon;

  return '\n    color: ' + path.colorScheme[colorScheme].color + ';\n    opacity: ' + path.opacity + ';\n  ';
};

var IconBoxStyled = exports.IconBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'IconBoxStyled'
})(['display:inline-flex;', ' ', ' ', ''], align, size, colorScheme);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-breadcrumbs/dist/BreadcrumbsItem/styles/IconBoxStyled.js
// module id = 547
// module chunks = 0